import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import { colord } from 'colord';
import { normalizeOpacity } from './normalizeOpacity';
import { SIMPLE_MARKER_COLOR, type UscgSymbol } from './uscgSymbology';

export function createSimpleMarkerSymbol(
  symbol: UscgSymbol,
  colorHex?: string,
  opacity?: number
): SimpleMarkerSymbol {
  const fallback = SIMPLE_MARKER_COLOR[symbol] ?? '#1e40af';
  const parsed = colord(colorHex || fallback);
  const { r, g, b } = parsed.isValid()
    ? parsed.toRgb()
    : { r: 30, g: 64, b: 175 };
  return new SimpleMarkerSymbol({
    color: [r, g, b, normalizeOpacity(opacity ?? 1)],
    size: 14,
    outline: {
      color: [r, g, b, 1],
      width: 1,
    },
  });
}
